// extracted by mini-css-extract-plugin
export var currencyInput = "_lx-1";
export var currencySymbol = "_lx-0";